import { useEffect } from 'react';
import { addEventListener } from '../utils/dom';
import { debounce } from '../utils/function';
var resizeHandlers = new Set();
var handleResize = function handleResize(event) {
  return resizeHandlers.forEach(function (handler) {
    return handler(event);
  });
};
export default function useResize(_ref) {
  var handler = _ref.handler,
    _ref$debounce = _ref.debounce,
    time = _ref$debounce === void 0 ? 0 : _ref$debounce,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  useEffect(function () {
    var prepared = time ? debounce(handler, time) : handler;
    var off = function off() {};
    if (enabled) {
      resizeHandlers.add(prepared);
    }
    if (resizeHandlers.size === 1) {
      off = addEventListener('resize', handleResize);
    }
    return function () {
      resizeHandlers.delete(prepared);
      if (resizeHandlers.size === 0) {
        off();
      }
    };
  }, [handler, time, enabled]);
}